import React from 'react';
import type { CMSProps } from 'Cms/tripadvisor-testimony/descriptor';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { TripadvisorTestimonies } from 'Components/widgets/tripadvisor-testimonies/TripadvisorTestimonies';
export type LineProps = CMSProps;
export const TripadvisorTestimonyLine = ({ id, reviews }: LineProps) => {
  const { isTablet } = useResponsive();
  return (
    <SiteContainer
      className="Line"
      data-testid="Line-TripadvisorTestimony"
      id={id}
      isWide={!isTablet}
    >
      <TripadvisorTestimonies items={reviews} />
    </SiteContainer>
  );
};
